import { Component } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';
import { toUTCWithoutChangingTime } from 'src/app/_helpers/utils';

@Component({
  selector: 'app-stacked-date-renderer',
  templateUrl: './stacked-date-renderer.component.html',
  styleUrls: ['./stacked-date-renderer.component.css'],
})
export class StackedDateRendererComponent implements ICellRendererAngularComp {
  bottomText!: string;

  topText!: string;

  // gets called once before the renderer is used
  agInit(params: StackedDateRendererParams): void {
    if (params.dateKey in params.data) {
      const dateSplit = toUTCWithoutChangingTime(params.data[params.dateKey])
        .tz('Europe/Zurich')
        .format('DD.MM.yyyy HH:mm')
        .split(' ');

      this.topText = dateSplit[0];
      this.bottomText = dateSplit[1];
    }
  }

  // gets called whenever the cell refreshes
  refresh(params: ICellRendererParams): boolean {
    return true;
  }
}

export type StackedDateRendererParams = ICellRendererParams & {
  dateKey: string;
};
